import { fromJS } from 'immutable';
import { SET_DECKS } from './constants';

const initialState = fromJS({
  decks: [],
  decksLoaded: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DECKS:
      return state.set('decks', action.payload.get('decks'))
        .set('decksLoaded', true);

    default:
      return state;
  }
}

export default reducer;
